import { SignalrClient } from '@ac/library-api';
import { acConfig } from '@ac/library-utils/dist/declarations';
import { LoginService } from '@ac/library-utils/dist/services';

let signalRClient = new SignalrClient(
  acConfig.apiUrl,
  () => LoginService.accessToken() || '',
  (LoginService.authData() || { tenantId: '' }).tenantId
);

export const setSignalRClient = (client: SignalrClient) => {
  signalRClient = client;
};

export const getSignalRClient = (): SignalrClient => {
  return signalRClient;
};



// WEBPACK FOOTER //
// ./src/services/signalRClient/signalRClient.ts